var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from 'react';
import { CheckboxContained, Text } from '@homeexchange/design';
import i18n from '../../../../i18n';
import styles from './reverseSearch.module.scss';
import Home from '../../../../models/Home';
export var ReverseSearchByHomes = function (_a) {
    var onChange = _a.onChange, filters = _a.filters, homes = _a.homes;
    var _b = useState([]), selectedHomeIds = _b[0], setSelectedHomeIds = _b[1];
    var _c = useState([]), eligibleHomes = _c[0], setEligibleHomes = _c[1];
    var _d = useState(filters), currentFilters = _d[0], setCurrentFilters = _d[1];
    var getHomeIcon = function (home) {
        var isPrivateRoom = home.get('shared_part') === Home.SHARED_PART_PRIVATE_ROOM;
        return isPrivateRoom ? 'private-room' : 'house';
    };
    useEffect(function () {
        var wholeUnits = homes.filter(function (home) { return home.get('shared_part') === Home.SHARED_PART_WHOLE_UNIT; });
        var privateRooms = homes.filter(function (home) { return home.get('shared_part') === Home.SHARED_PART_PRIVATE_ROOM; });
        var eligibleHomes = __spreadArray(__spreadArray([], wholeUnits, true), privateRooms, true).reduce(function (acc, home) {
            var _a, _b, _c, _d;
            var locale = i18n.language;
            var homeTitle = (_c = (_b = (_a = home
                .get('descriptions')) === null || _a === void 0 ? void 0 : _a.find(function (description) { return description.locale === locale && description.title !== ''; })) === null || _b === void 0 ? void 0 : _b.title) !== null && _c !== void 0 ? _c : (_d = home.get('descriptions').find(function (description) { return description.title !== ''; })) === null || _d === void 0 ? void 0 : _d.title;
            home.set('title', homeTitle);
            if (home.isOffline()) {
                return acc;
            }
            if (acc.find(function (h) { return h.get('address') === home.get('address'); })) {
                return acc;
            }
            return __spreadArray(__spreadArray([], acc, true), [home], false);
        }, []);
        setEligibleHomes(eligibleHomes);
    }, [homes]);
    useEffect(function () {
        var _a;
        var parsedFilters = JSON.parse(JSON.stringify(filters));
        var reverseValues = ((_a = parsedFilters === null || parsedFilters === void 0 ? void 0 : parsedFilters.reverse) !== null && _a !== void 0 ? _a : []).map(function (id) { return Number(id); }) || [];
        setCurrentFilters(__assign(__assign({}, parsedFilters), (reverseValues.length > 0 && { reverse: reverseValues })));
        setSelectedHomeIds(reverseValues);
    }, [filters]);
    var onHomeItemToggle = function (homeId) { return __awaiter(void 0, void 0, void 0, function () {
        var idsToUpdate, updatedFilters;
        return __generator(this, function (_a) {
            idsToUpdate = selectedHomeIds.includes(homeId)
                ? selectedHomeIds.filter(function (id) { return id !== homeId; })
                : __spreadArray(__spreadArray([], selectedHomeIds, true), [homeId], false);
            setSelectedHomeIds(idsToUpdate);
            if (idsToUpdate.length === 0) {
                delete currentFilters.reverse;
                onChange(currentFilters, false);
            }
            else {
                delete currentFilters.preferred_destination;
                updatedFilters = __assign(__assign({}, currentFilters), { reverse: idsToUpdate });
                onChange(updatedFilters, false);
            }
            return [2 /*return*/];
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement(Text, { isSmall: true, className: styles['description'] }, i18n.t('search:filter.reverse_description')),
        eligibleHomes.map(function (home) { return (React.createElement(CheckboxContained, { key: home.id, label: home.get('title'), checked: selectedHomeIds.includes(Number(home.id)), onChange: function () { return onHomeItemToggle(Number(home.get('id'))); }, name: home.get('address'), icon: getHomeIcon(home), description: home.get('address') })); })));
};
